import {VariantConfigT} from '@/lib/types/colors.types';

export const warningConfig: VariantConfigT = {
  basic: {
    icon: 'warning',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'warning',
    active: 'warning',
  },
  outline: {
    icon: 'warning',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'warning',
    iconHover: 'warning',
    iconActive: 'warning',
    hover: 'warning',
    active: 'warning',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
